import { createTRPCClient, httpBatchLink, httpLink, splitLink } from "@trpc/client";
import type { TRPCClient } from "@trpc/client";
import type { AppRouter } from "#trpc/router.js";
import { PUBLIC_BASE_URL } from "$app/env/public";

// Browser: relative URL so dynamic dev ports work and prod uses the serving origin.
// SSR: no window → fall back to the configured absolute base.
const url = typeof window === "undefined" ? `${PUBLIC_BASE_URL}/api/trpc` : "/api/trpc";

/** Browser singleton -- used in components (createQuery, mutate calls) */
export const trpcBrowser: TRPCClient<AppRouter> = createTRPCClient<AppRouter>({
	links: [
		splitLink({
			condition: (operation) => operation.context.skipBatch === true,
			true: httpLink({ url }),
			false: httpBatchLink({ url })
		})
	]
});

/** Request-scoped client -- used in +page.ts load functions for SSR prefetch.
 *  Pass SvelteKit's `fetch` so cookies propagate during SSR.
 *
 *  Always relative: SvelteKit's `fetch` resolves it against the request origin
 *  during SSR, so the serving port and domain are always right. An absolute
 *  `PUBLIC_BASE_URL` here refuses the connection on any dev port other than the
 *  configured one, and targets the wrong origin on multi-domain (www) routes. */
export function trpcLoad(fetch: typeof globalThis.fetch): TRPCClient<AppRouter> {
	return createTRPCClient<AppRouter>({
		links: [
			httpBatchLink({
				url: "/api/trpc",
				fetch
			})
		]
	});
}
